import React from 'react';
import { array, bool, elementType, func, node, object, string } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import {
  ListingCard,
  SearchListingCard,
  ListListingCard,
  PaginationLinks,
  Button,
} from '../../../components';

import css from './SearchResultsPanel.module.css';
import StoreCard from '../../../components/ListingCard/StoreCard';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isMapVariant,
    isSearch = true,
    stores,
    intl,
    commissionData,
    commissionLoading,
    commissionError,
    ListingCardComponent,
    getListingCardProps,
    pageName,
    pagePathParams,
    showToggleMap,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={pageName}
        pagePathParams={pagePathParams}
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  const cardRenderSizes = isMapVariant => {
    if (isMapVariant) {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 767px) 100vw',
        `(max-width: 1023px) ${panelMediumWidth}vw`,
        `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
        `${panelLargeWidth / 3}vw`,
      ].join(', ');
    } else {
      // Panel width relative to the viewport
      const panelMediumWidth = 50;
      const panelLargeWidth = 62.5;
      return [
        '(max-width: 549px) 100vw',
        '(max-width: 767px) 50vw',
        `(max-width: 1439px) 26vw`,
        `(max-width: 1920px) 18vw`,
        `14vw`,
      ].join(', ');
    }
  };

  const DefaultListingContainer = isSearch ? SearchListingCard : ListListingCard;
  const ListingContainer = ListingCardComponent || DefaultListingContainer;

  const availableStores = stores && Array.isArray(stores) && stores.length;

  return (
    <>
      <div className={classes}>
        <div
          className={
            isSearch
              ? isMapVariant
                ? css.listingCardsMapVariant
                : css.listingCards
              : css.noSearchListingCards
          }
        >
          {listings.map(l => (
            <ListingContainer
              className={css.listingCard}
              key={l.id.uuid}
              listing={l}
              renderSizes={cardRenderSizes(isMapVariant)}
              setActiveListing={setActiveListing}
              stores={stores}
              creators={props.creators}
              commissionData={commissionData}
              commissionLoading={commissionLoading}
              commissionError={commissionError}
              {...(getListingCardProps ? getListingCardProps(l) : {})}
            />
          ))}
          {props.children}
        </div>
        {showToggleMap && props.toggleMap ? (
          <Button type="button" className={css.toggleMap} onClick={() => props.toggleMap()}>
            {intl.formatMessage({ id: 'SearchPage.toggleMap' })}
          </Button>
        ) : null}
        {paginationLinks}
        {availableStores ? (
          <>
            <h2 className={css.storesHeading}>Bowtackle Certified Sellers</h2>
            <div className={css.storesContainer}>
              {stores
                .sort((a, b) => (b.listings?.length || 0) - (a.listings?.length || 0))
                .map(store => (
                  <StoreCard store={store} key={store?.id?.uuid} />
                ))}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  stores: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isMapVariant: true,
  ListingCardComponent: null,
  getListingCardProps: null,
  pageName: 'SearchPage',
  pagePathParams: {},
  showToggleMap: true,
};

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  getListingCardProps: func,
  ListingCardComponent: elementType,
  listings: array,
  stores: array,
  pagination: propTypes.pagination,
  pageName: string,
  pagePathParams: object,
  rootClassName: string,
  search: object,
  showToggleMap: bool,
  isMapVariant: bool,
};

export default SearchResultsPanel;
